import type CSS from 'csstype';

import { extractCssStyle } from '../../utilities';

export interface BorderStylingProps {
  border?: CSS.Property.Border;
  borderRadius?: CSS.Property.BorderRadius;
  borderBottom?: CSS.Property.BorderBottom;
  borderTop?: CSS.Property.BorderBottom;
  borderColor?: CSS.Property.BorderColor;
}

export const BorderStyling = (props: BorderStylingProps) => extractCssStyle(props);
